<template>
  <div class="company">
    <div class="tixing">
      <h4>重要提醒</h4>
      <p class="first">
        通过该平台提交的所有资料将用于您的线上宣传，也会在展会微信公众号、官网等主办方的宣传中使用，不包括展会会刊。在参展商不做出特别声明的情况下，展会主办方有权使用参展商通过本平台所发布的文字、照片、视频、企业Logo等信息，用于第19届中国国际采矿展宣传使用。为助力您聚集线上关注、提升展前宣传、获得更好的参展效果和线上商机，请务必完整、准确填写！所上传或填写的公司、产品等相关宣传内容请务必注意符合广告法等相关法律法规，避免出现不合规的表述。
      </p>
      <p>建议您在<i>2023年08月30日</i>前完成资料的填写及上传</p>
    </div>
    <!-- 表单 -->
    <div class="formaction">
      <div class="text">
        <div class="text_box">
          <p>
            公司名称·中文：<span>{{ companyInfo[0].name }}</span>
          </p>
          <p>
            公司名称·英文：<span>{{ companyInfo[0].english }}</span>
          </p>
          <p class="three">
            企业类型：<span>{{ companyInfo[0].nature }}</span>
          </p>
          <p>
            <i>*</i>以上信息如需更改请联系展会组委会：<span>010-84293556</span>
          </p>
        </div>
      </div>
      <!-- 表单控件 -->
      <div class="formsubmit">
        <el-form ref="form" :model="sizeForm" label-width="200px" size="mini">
          <el-form-item label="公司地址:">
            <el-input
              v-model="sizeForm.address"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮编:">
            <el-input
              v-model="sizeForm.postcode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司电话:">
            <el-input v-model="sizeForm.iphone" placeholder="请输入"></el-input>
            <p>用于企业页面展示</p>
          </el-form-item>
          <el-form-item label="E-mail:">
            <el-input v-model="sizeForm.email"></el-input>
            <p>用于企业页面展示</p>
          </el-form-item>
          <el-form-item label="公司网址:">
            <el-input v-model="sizeForm.url"></el-input>
          </el-form-item>
          <el-form-item label="公司Logo·中文：" :required="true">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <p>格式：jpg, png, gif; 建议尺寸：693*399px; 大小：2M内</p>
            </el-upload>
          </el-form-item>
          <el-form-item label="公司Logo·英文：">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <p>格式：jpg, png, gif; 建议尺寸：693*399px; 大小：2M内</p>
            </el-upload>
          </el-form-item>
          <el-form-item label="公司介绍·中文:">
            <el-input
              type="textarea"
              :rows="4"
              v-model="sizeForm.instroduce"
              @input="inputArea"
            ></el-input>
            <p>
              字数：还可输入<span>{{ currentLength }}</span
              >字符，最多可输入1000个字符（含标点及空格）
            </p>
          </el-form-item>
          <el-form-item label="公司介绍·英文:">
            <el-input
              type="textarea"
              :rows="4"
              v-model="sizeForm.Enginstro"
              @input="inputArea1"
            ></el-input>
            <p>
              字数：还可输入<span>{{ EcurrentLength }}</span
              >字符，最多可输入1000个字符（含标点及空格）
            </p>
          </el-form-item>
          <el-form-item label="企业宣传视频封面:">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <p>格式：jpg, png, gif; 建议尺寸：693*399px; 大小：2M内</p>
            </el-upload>
          </el-form-item>
          <!-- 上传视频 -->
          <el-form-item label="上传视频·中文:">
            <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <i class="select">选择文件</i>
              <p>格式：mp4, mov; 大小：100M内</p>
            </el-upload>
          </el-form-item>

          <el-form-item label="上传公司微信公众号二维码:">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <div class="box">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="select select1">选择文件</i>
              </div>
              <p>建议上传图片大小为：258*258px</p>
            </el-upload>
          </el-form-item>
          <el-button type="primary" @click="submitForm('sizeForm')"
            >提交</el-button
          >
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "company",
  data() {
    return {
      //公司介绍文字长度
      currentLength: "1000",
      //英文介绍文字长度
      EcurrentLength: "1000",
      //公司信息
      companyInfo: [
        {
          name: "中国煤炭工业国际咨询责任有限公司",
          english: "CHINA COAL CONSULTANT INTERNATIONAL",
          nature: "国内展商",
        },
      ],
      sizeForm: {
        address: "", //公司地址
        postcode: "", //邮编
        iphone: "", //公司电话
        email: "", //邮箱
        url: "", //公司网址
        instroduce: "", // 公司介绍中文
        Enginstro: "", // 公司介绍英文
      },
    };
  },

  components: {},

  computed: {},

  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //监听文本框长度
    inputArea() {
      if (this.sizeForm.instroduce.length < 1000) {
        this.currentLength = 1000-this.sizeForm.instroduce.length;
      } else {
        this.currentLength = 0;
        this.sizeForm.instroduce=this.sizeForm.instroduce.length(0,1000)
      }
    },
    inputArea1() {
      if (this.sizeForm.Enginstro.length < 1000) {
        this.EcurrentLength = 1000 - this.sizeForm.Enginstro.length;
      } else {
        this.EcurrentLength = 0;
        this.sizeForm.Enginstro = this.sizeForm.Enginstro.slice(0, 1000);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.company {
  box-sizing: border-box;
  padding: 0 43px 8px 26px;
  h4 {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff190c;
    line-height: 19px;
    margin-bottom: 8px;
  }
  p {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 19px;

    i {
      color: red;
      font-style: normal;
    }
  }
  .first {
    margin-bottom: 19px;
  }
  .text {
    border-bottom: 1px solid #e9e9e9;
    margin-top: 43px;
    padding-bottom: 17px;

    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
    }
    p:last-child {
      margin-left: 95px;
      span {
        color: #006fb8;
      }
    }
    .text_box {
      display: flex;
      // border: 1px solid red;
      width: 500px;
      flex-direction: column;
      justify-content: flex-start;
      margin: 0 auto;
      p {
        margin-bottom: 18px;
      }
      .three {
        margin-left: 31px;
      }
    }
  }
  .formsubmit {
    width: 630px;
    margin: 0 auto;
    margin-top: 17px;
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: skyblue;
      // border: 1px solid red;
      width: 318px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 19px;
      span {
        color: red;
      }
    }
    .select {
      display: block;
      font-style: normal;
      width: 95px;
      height: 28px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .select1 {
      margin: 0 auto;
    }
    .box {
      width: 175px;
      height: 175px;
      // border: 1px solid red;
      background: #f1f1f1;
      display: flex;
      align-items: center;
    }
  }
}
</style>
<style scoped>
.formaction >>> .el-button--primary {
  width: 70px;
  height: 28px;
  background: #006fb8;
  text-align: center;
  margin-left: 190px;
  line-height: 4px;
}
</style>